import { Info as InfoIcon } from '@phosphor-icons/react';
import clsx from 'clsx';
import { Tooltip } from './Tooltip';

type InfoProps = {
  value: string;
  className?: string;
};

export const Info = ({ value, className = '' }: InfoProps) => {
  return (
    <Tooltip content={value} position="top" zIndex={50}>
      <InfoIcon
        className={clsx(
          'w-4 h-4 text-primary hover:text-primary-700 transition-colors -translate-y-[1px]',
          className,
        )}
        weight="bold"
      />
    </Tooltip>
  );
};
